<template>
  <label class="switch">
    <input type="checkbox" 
           v-model="value" 
           :true-value="trueValue" 
           :false-value="falseValue"
           :data-action="dataAction"
           :data-eventcategory="dataCategory" />
    <span class="slider round"></span>
  </label>
</template>

<script>
export default {
  props: {
    trueValue: {
      type: [String, Number, Boolean],
      default: true
    },
    falseValue: {
      type: [String, Number, Boolean],
      default: false
    },
    defaultValue: {
      type: [String, Number, Boolean],
      default: false
    },
    dataAction: {
      type: String,
      default: null
    },
    dataCategory: {
      type: String,
      default: null,
    }
  },
  data() {
    return {}
  },
  computed: {
    value: {
      get() {
        return this.defaultValue
      },
      set(value) {
        this.$emit("changed-value", value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles/_ButtonSwitch";
</style>